// A native dialog keeps the gallery in place and supports Escape and keyboard focus.
if (!customElements.get('ayna-product-video')) {
  customElements.define('ayna-product-video', class extends HTMLElement {
    connectedCallback() {
      if (this.videoController) return;
      const trigger = this.querySelector('[data-ayna-video-open]');
      const closeButton = this.querySelector('[data-ayna-video-close]');
      const dialog = this.querySelector('dialog');
      const video = this.querySelector('video');
      const error = this.querySelector('.ayna-product-video__error');
      if (!trigger || !dialog || !video || !closeButton) return;
      this.videoController = new AbortController();
      const options = { signal: this.videoController.signal };
      trigger.addEventListener('click', (event) => {
        event.stopPropagation();
        if (dialog.open) return;
        dialog.showModal();
        if (!video.getAttribute('src')) video.src = video.dataset.aynaVideoSrc;
        video.play().catch(() => { /* Native controls remain available. */ });
      }, options);
      closeButton.addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, options);
      dialog.addEventListener('close', () => {
        video.pause();
        trigger.focus({ preventScroll: true });
      }, options);
      video.addEventListener('error', () => { if (error) error.hidden = false; }, options);
    }
    disconnectedCallback() {
      const dialog = this.querySelector('dialog');
      if (dialog?.open) dialog.close();
      this.querySelector('video')?.pause();
      this.videoController?.abort();
      this.videoController = null;
    }
  });
}
